import { countryShortName } from "../../../Utils/countryCodes"
import { getDates } from "../../../Utils/utils"

// The [from, to] pair a calendar preset resolves to. null where the preset has no bounds
// ("All time"), which every caller treats as no narrowing.
export const rangeOfPeriod = (period) => {
  const d = getDates(period)
  return d?.start_date && d?.end_date ? [d.start_date, d.end_date] : null
}

// Concise, common country names (shared helper), e.g. "United Kingdom" rather than
// the long ISO form. Used by the country chart/table.
export const countryName = countryShortName
